<template>
  <div id="works">
    <h2>
      WORKS
      <span>制作実績</span>
    </h2>
    <div class="works-list">
      <swiper
        :slides-per-view="4.5"
        :space-between="80"
        :pagination="true"
        :breakpoints="breakpoints"
        :modules="modules"
      >
        <swiper-slide v-for="(item, i) in lineuplist" :key="i">
          <WorksCard
            :locate="item.locate"
            :id="item.id"
            :name="item.name"
            @cardclick="Modalemit"
          />
        </swiper-slide>
      </swiper>
    </div>

    <transition name="worksmodal" appear mode="out-in">
      <Modal
        v-if="modalstate"
        :list="modaltarget"
        :name="modaltargetname"
        @modalclose="modalstate = $event.state"
      />
    </transition>
  </div>
</template>

<script>
import Modal from "@/components/PartsWorksModal.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import WorksCard from "@/components/PartsWorksCard.vue";
export default {
  components: {
    WorksCard,
    Swiper,
    SwiperSlide,
    Modal,
  },
  data() {
    return {
      lineuplist: [
        { locate: "jikiba4", id: "jikiba4b", name: "WORKS#11" },
        { locate: "jikiba4", id: "jikiba4a", name: "WORKS#10" },
        { locate: "jikiba2", id: "jikiba2b", name: "WORKS#9" },
        { locate: "jikiba3", id: "jikiba3h", name: "WORKS#8" },
        { locate: "jikiba3", id: "jikiba3g", name: "WORKS#7" },
        { locate: "jikiba3", id: "jikiba3d", name: "WORKS#6" },
        { locate: "kamikawahara1", id: "kamikawahara1c", name: "WORKS#5" },
        { locate: "model", id: "model4", name: "WORKS#4" },
        { locate: "model", id: "model3", name: "WORKS#3" },
        { locate: "model", id: "model2", name: "WORKS#2" },
        { locate: "model", id: "model1", name: "WORKS#1" },
      ],
      modalstate: false,
      modaltarget: "",
      modaltargetname: "",
    };
  },
  methods: {
    Modalemit({ state, target, name }) {
      this.modalstate = state;
      this.modaltarget = target;
      this.modaltargetname = name;
    },
    ModalOpen(imgurl) {
      this.modalstate = true;
      this.modalimage = imgurl;
      return;
    },
  },
  setup() {
    return {
      modules: [Pagination],
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        960: {
          slidesPerView: 3.5,
          spaceBetween: 40,
        },
        1280: {
          slidesPerView: 3.5,
          spaceBetween: 40,
        },
        1560: {
          slidesPerView: 4.5,
          spaceBetween: 40,
        },
      },
    };
  },
};
</script>
<style lang="scss">
// transition
.worksmodal-enter-active {
  .overlay {
    opacity: 0;
  }
  .modalcontents {
    opacity: 0;
    transform: rotate(5deg);
    transform-origin: 50% 200%;
  }
}
.worksmodal-enter-to {
  transition: 0.25s;
  .overlay {
    opacity: 1;
    transition: 0.5s;
  }
  .modalcontents {
    opacity: 1;
    transform: rotate(0);
    transform-origin: 50% 200%;
    transition: 0.25s;
  }
}
.worksmodal-leave-active {
  transition: 0.25s;
  .overlay {
    opacity: 0;
    transition: 0.1s;
  }
  .modalcontents {
    opacity: 0;
    transform: rotate(-5deg);
    transform-origin: 50% 200%;
    transition: 0.25s;
  }
}
</style>
<style lang="scss" scoped>
#works {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding-bottom: $v-gap;
  &::after {
    content: "";
    position: absolute;
    background-color: #eee;
    width: 50%;
    height: 100%;
    right: 0;
    top: 0;
    border-radius: 5vw 0 0 5vw;
    z-index: -1;
  }

  h2 {
    padding: 0 $h-gap;
    font-weight: bold;
    font-size: 3rem;
    margin-bottom: 1em;
    span {
      margin-left: 1em;
      font-size: 1rem;
    }
  }
}
.works-list {
  padding: 0 $h-gap;
  overflow: visible;
  .swiper {
    overflow: visible;
  }
}
//
</style>
